// ENUMS #############################################################
export enum ContractEntityTooltipIdentifierEnum {
	ARCHIVING_CONTRACT_TYPE = 'contractType',
	ARCHIVING_CONTRACTED_ERSES = 'contractedErses',
	COMMON_CONTRACT_FROM = 'contractFrom',
	COMMON_CONTRACT_TO = 'contractTo',
	COMMON_CUSTOMER_IDENTIFIER = 'customerIdentifier',
	COMMON_CUSTOMER_NAME = 'customerName',
	COMMON_PROJECT_NUMBER = 'projectNumber',
	COMMON_STATUS = 'status',
	FISKAL_CONTRACT_TYPE_GROUP = 'contractTypeGroup',
	FISKAL_CONTRACTED_BUSINESS_PREMISES = 'contractedBusinessPremises',
	FISKAL_CONTRACTED_BUSINESS_PREMISES_LIMIT = 'businessPremisesLimit',
	FISKAL_CONTRACTED_CLOUD_ERS = 'contractedCloudErs',
	FISKAL_CONTRACTED_FCC_DATA_CENTER_ENABLED = 'fccDataCenterEnabled',
	FISKAL_CONTRACTED_FCC_DATA_CENTER_ERS = 'contractedFccDataCenterErs',
	FISKAL_CONTRACTED_FCC_DATA_CENTER_VOLUME = 'contractedFccDataCenterVolume',
	FISKAL_CONTRACTED_FCC_DATA_BUSINESS_PREMISSES = 'contractedFccDataCenterBusinessPremises',
	FISKAL_CONTRACTED_TOKEN_ERS = 'contractedTokenErs',
	FISKAL_VOLUME = 'volume'
}

// CONSTANTS #########################################################


// TYPES #############################################################


// INTERFACES ########################################################
export interface IContractEntityTooltipItem {
	identifier: ContractEntityTooltipIdentifierEnum;
}


// ENTITIES ##########################################################

